import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
function Vision() {
    const { t } = useTranslation();
    return (
        <div className='vision-container'>
            <Form.Row >
                <Col style={{margin: '4em 0'}}>
                    <h1>{t('who.vision.title')}</h1>
                    <h5>{t('who.vision.desc')}</h5>
                </Col>
                <Col style={{margin: '4em 0'}}>
                    <h1>{t('who.message.title')}</h1>
                    <h5>{t('who.message.desc')}</h5>
                </Col>
                <Col style={{margin: '4em 0'}}>
                    <h1>{t('who.values.title')}</h1>
                    <h5>{t('who.values.desc')}</h5>
                </Col>
            </Form.Row>
        </div>
    );
}

export default Vision;
